// Fixed category filter order for the Stipulations panel (matches categoryCode
// values returned by the BFF). "All Stips" is a client-side sentinel, not a
// real categoryCode, and always renders last.
export const STIPULATION_CATEGORIES = ["Income", "Bank", "Residence", "Vehicle", "Financial", "References", "Status", "Other Backend Products"] as const;

export type StipulationCategory = (typeof STIPULATION_CATEGORIES)[number];

export const ALL_STIPULATION_CATEGORIES = "all";

export const DEFAULT_STIPULATION_CATEGORY: StipulationCategory = "Income";

/** Maps each category to its corresponding workbenchScreen value. */
export const CATEGORY_TO_WORKBENCH_SCREEN: Record<StipulationCategory, string> = {
  Income: "INCOME",
  Bank: "BANK",
  Residence: "RESIDENCE",
  Vehicle: "VEHICLE",
  Financial: "FINANCE",
  References: "REFERENCE",
  Status: "STATUS",
  "Other Backend Products": "OBP",
};

/** The subset of categories that have a corresponding scrollable section in the Signers card. */
export type ScrollSpySection = Extract<StipulationCategory, "Income" | "Bank" | "Residence">;
